"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var styles = tslib_1.__importStar(require("./Alert.style"));

var Button_1 = tslib_1.__importDefault(require("../Buttons/Button"));

function Alert(_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      children = _ref.children,
      confirmButtonText = _ref.confirmButtonText,
      cancelButtonText = _ref.cancelButtonText,
      onConfirmClick = _ref.onConfirmClick,
      onCancelClick = _ref.onCancelClick;

  function handleConfirmClick() {
    if (onConfirmClick && onConfirmClick()) {
      toggle(false);
    }
  }

  function handleCancelClick() {
    onCancelClick && onCancelClick();
    toggle(false);
  }

  function handleClosableClick() {
    toggle(false);
  }

  function handleConatinerClick(event) {
    event.stopPropagation();
  } // test


  return react_dom_1.createPortal(jsx_runtime_1.jsxs("div", Object.assign({
    css: [styles.root, isOpen ? styles.rootShow : styles.rootHide],
    className: className,
    onClick: handleClosableClick
  }, {
    children: [jsx_runtime_1.jsx("div", {
      css: [styles.backdrop, isOpen ? styles.backdropShow : styles.backdropHide]
    }, void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: [styles.alert, isOpen ? styles.alertShow : styles.alertHide],
      onClick: handleConatinerClick
    }, {
      children: jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.container
      }, {
        children: [jsx_runtime_1.jsx("div", Object.assign({
          css: styles.content
        }, {
          children: children
        }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.footer
        }, {
          children: [cancelButtonText && jsx_runtime_1.jsx(Button_1.default, Object.assign({
            type: "gray",
            size: "medium",
            onClick: handleCancelClick
          }, {
            children: cancelButtonText
          }), void 0), jsx_runtime_1.jsx(Button_1.default, Object.assign({
            type: "primary",
            size: "medium",
            onClick: handleConfirmClick
          }, {
            children: confirmButtonText
          }), void 0)]
        }), void 0)]
      }), void 0)
    }), void 0)]
  }), void 0), document.body);
}

exports.default = react_1.memo(Alert);